import React from 'react';
import { useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import '../enviro-deep-research/index.scss';

const StyledTooltip = styled(ReactTooltip)`
  max-width: 200px !important;
`;

const EnviroChemicalAISidebar: React.FC<{ isHovered: boolean; setIsHovered: (hover: boolean) => void }> = () => {
  const history = useHistory();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: 325,
        height: '100vh',
        overflowY: 'auto',
        backgroundColor: '#282a2c',
        zIndex: 1039
      }}
    >
      <div style={{ padding: '8px', borderBottom: '1px solid #3a3a3a' }}>
        <i
          className="bi bi-chevron-double-left"
          onClick={() => history.push('/')}
          style={{
            fontSize: '20px',
            color: '#fff',
            cursor: 'pointer',
            padding: '8px',
            display: 'block'
          }}
          data-tip="Go back to search"
          data-for="back-to-search"
        />
      </div>
      <div style={{ padding: '16px', color: '#fff' }}>
        <div
          style={{
            padding: '12px 16px',
            backgroundColor: '#18181b',
            border: '1px solid #3a3a3a',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            marginBottom: '12px'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#212124'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#18181b'}
          onClick={() => history.push('/enviro-chemical-ai/new-chemical-review')}
        >
          <span style={{ fontWeight: 600, fontSize: '16px', color: '#fff' }}>New Chemical Review</span>
        </div>
        <div
          style={{
            padding: '12px 16px',
            backgroundColor: '#18181b',
            border: '1px solid #3a3a3a',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            marginBottom: '12px'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#212124'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#18181b'}
        >
          <span style={{ fontWeight: 600, fontSize: '16px', color: '#fff' }}>Chemical Substitution Analysis</span>
        </div>
        <div
          style={{
            padding: '12px 16px',
            backgroundColor: '#18181b',
            border: '1px solid #3a3a3a',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            marginBottom: '12px'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#212124'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#18181b'}
        >
          <span style={{ fontWeight: 600, fontSize: '16px', color: '#fff' }}>Exposure Assessment</span>
        </div>
        <div
          style={{
            padding: '12px 16px',
            backgroundColor: '#18181b',
            border: '1px solid #3a3a3a',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#212124'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#18181b'}
        >
          <span style={{ fontWeight: 600, fontSize: '16px', color: '#fff' }}>Waste Characterization</span>
        </div>
      </div>
      <StyledTooltip id="back-to-search" effect="solid" place="right" />
    </div>
  );
};

export default EnviroChemicalAISidebar;

